export default __webpack_public_path__ + "fonts/49f764c7ceb94509be5d2326e5baeddd.ttf";